import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { StateService } from '@uirouter/core';
import { Subscription } from 'rxjs';

import { Accessibility, Cloudinary, Util, XmStore, XmStoreUtil } from 'core/services';

import { CmsDataDetail } from 'store/cms/models';

@Component({
    selector: 'xm-unlimited-tier-selector',
    templateUrl: './unlimited-tier-selector.html',
    styleUrls: ['./unlimited-tier-selector.scss'],
    standalone: false
})
export class XmUnlimitedTierSelector implements OnInit, OnDestroy {
    @Input() public unlimitedTierPlan: CmsUnlimitedTierPlan;
    @Input() public tierPrice: number;
    @Input() public priceSymbol?: string;
    @Input() public showInUseBadge: boolean;
    @Input() public showScheduledBadge: boolean;
    @Output() public emitPlanCode: EventEmitter<string> = new EventEmitter<string>();

    public cmsDataDetailPageData: CmsDataDetail;
    public inUse: string;
    public inUseIcon: MediaImageOptions;
    public scheduled: string;
    public scheduledIcon: MediaImageOptions;

    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];

    constructor(accessibility: Accessibility, xmStore: XmStore, state: StateService) {
        Object.assign(this, { accessibility, xmStore, state });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsDataDetail>(CmsDataDetail), (pageData: CmsDataDetail) => {
            this.cmsDataDetailPageData = pageData;
            this.inUse = this.cmsDataDetailPageData.inUse;
            this.scheduled = this.cmsDataDetailPageData.scheduled;

            this.inUseIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.cmsDataDetailPageData.inUseIcon)
            };

            this.scheduledIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.cmsDataDetailPageData.scheduledIcon)
            };
        }));
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

    public tierSelect(planCode: string): void {
        this.emitPlanCode.emit(planCode);
    }
}
